<template>
  <div class="process wrapper-secondary">
    <span class="process-pre-text">
      {{ $t("process_pre_text") }}
    </span>
    <h2 class="process-title">
      SCORE<span>68</span> {{ $t("process_title") }} <br />
      {{ $t("process_description") }}
    </h2>
    <p class="process-text">
      {{ $t("process_sicret") }}
    </p>
    <!-- <a class="process-botton" href="#">
      {{ $t("process_bottom") }}
    </a>
    <p>
      {{ $t("process_info") }}
    </p> -->
  </div>
</template>

<script>
export default {
  name: "Process",
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.process {
  text-align: center;
  margin-bottom: 25px;
  padding: 60px 30px;
}

.process-title {
  padding: 0;
  line-height: 1.2;
  font-weight: 600;
  text-align: inherit;
  letter-spacing: -0.02em;
  color: var(--back-color);
  font-size: 44px;
  margin: 10px 0;

  span {
    color: var(--brand-color);
  }
}

.process-text {
  text-align: inherit;
  // margin-bottom: 60px;
  font-size: 18px;
}

.process-pre-text {
  color: var(--brand-color);
  font-weight: 800;
  text-align: center;
}

.process-botton {
  cursor: pointer;
  display: inline-block;
  padding: 19px 39px;
  font-weight: 600;
  font-size: 20px;
  line-height: 1.2;
  border-radius: 100px;
  color: var(--body-color);
  background-color: var(--back-color);
  transition: 0.3s all;
  margin-bottom: 6px;
}
@media screen and (max-width: $fullhd) {
  .process-title {
    font-size: 28px;
  }
  .process-botton {
    font-size: 16px;
  }
}
</style>
